module.exports = __webpack_public_path__ + "static/img/upload_img.b6639bb2.png";